import React from 'react';
import store from 'store';
import RestService from '@services/REST/RestService';
import CacheService from '@services/Cache/CacheService';
import DocumentHelper from '@helpers/DocumentHelper';

class ActiveView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            view: store.get('modelName'),
            taxonomyMaps: [],
            open: false,
            currentTaxonomyMap: 'global',
            attachedModels: [],
            taxonomyOpen: false
        }
        this.openTaxonomyBox = this.openTaxonomyBox.bind(this);
        this.addTaxMap = this.addTaxMap.bind(this);
        this.updateCurrentTaxonomy = this.updateCurrentTaxonomy.bind(this);
        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.toggleDropdownKeyup = this.toggleDropdownKeyup.bind(this);
        this.onSwitchViewKeyup = this.onSwitchViewKeyup.bind(this);
    }

    componentDidMount() {
        this.getAvailableModels();
        this.addCloseEvent();
    }

    addCloseEvent() {
        document.addEventListener('click', e => {
            if (!DocumentHelper.closest(e.target, '.global-view-name')) {
                this.setState(state => {
                    state.open = false;
                    return state;
                });
            }
        });
        document.addEventListener('keyup', e => {
            if (!DocumentHelper.closest(e.target, '.global-view-name')) {
                this.setState(state => {
                    state.open = false;
                    return state;
                });
            }
        });
    }

    getAvailableModels() {
        CacheService.data().then(resp => {
            let attachedModels = []
            let models = store.get('activeModels') //resp.data.data
            if (models) {
                models.filter((x) => {
                    if (x.isDefault) {
                        attachedModels.push(x.modelId)
                    }
                })
            }
            let tMaps = models ? models : []
            // tMaps.unshift(this.state.globalTaxonomyMap)
            this.setState({
                taxonomyMaps: tMaps,
                // currentTaxonomyMap: current ? current.ModelId : this.state.globalTaxonomyMap.ModelId,
                attachedModels: attachedModels,
                modelNameLoaded: true
            });
        })
            .catch(e => {
                console.log(e)
            });

    }

    openTaxonomyBox() {
        this.setState({ taxonomyOpen: !this.state.taxonomyOpen })
    }

    addTaxMap(id) {
        let attachedModels = this.state.attachedModels;
        if (id == 'global') {
            attachedModels = [];
        } else {
            attachedModels = [id];
            // const currentIdx = attachedModels.indexOf(id);
            // if (currentIdx > -1){
            //     attachedModels.splice(currentIdx, 1);
            // }else{
            //     attachedModels.push(id);
            // }
        }
        this.setState({ attachedModels: attachedModels })
        this.updateCurrentTaxonomy(attachedModels)
    }

    onSwitchViewKeyup(e) {
        if (e.keyCode !== 13) return;
        const id = e.target.dataset.id;
        this.addTaxMap(id);
    }

    updateCurrentTaxonomy(attachedModels) {
        // let models = this.state.taxonomyMaps;
        RestService.setCurrentModel({ models: attachedModels }).then(resp => {
            // for (var idx in models){
            //     if (models[idx].ModelId == this.state.currentTaxonomyMap){
            //         store.set('modelName', models[idx].ModelName)
            //         document.getElementById('modelNameBreadcrumb').innerText = store.get('modelName')
            //     }
            // }
            CacheService.resetCache('taxonomy')
            window.location.reload();
            this.setState({ modelNameLoaded: true })
        })
            .catch(e => {
                console.log(e)
                this.setState({ modelNameLoaded: true })
            });

    }

    toggleDropdown() {
        this.setState({ open: !this.state.open });
    }

    toggleDropdownKeyup(e) {
        if (e.keyCode === 13 || e.keyCode === 40) this.toggleDropdown();
    }

    onSwitchKeydown(e) {
        if (e.keyCode === 40) e.preventDefault();
    }

    render() {
        return (
            <span className="global-view-name hover">
                <span className="pull-left model-name">Current Taxonomy View:</span>
                <span id="modelNameBreadcrumb" className="ml-2 pull-left">{this.state.view}</span>
                <span
                    className="position-relative model-dropdown pull-left"
                    tabIndex="0"
                    onKeyUp={this.toggleDropdownKeyup}
                    onClick={this.toggleDropdown}
                >
                    <i className="fa fa-angle-down ml-2" style={{ border: (this.state.open ? '1px solid #c2cfd6' : 'none') }}></i>
                    <div className="dropdown-model-menu" style={{ display: this.state.open ? 'block' : 'none' }}>
                        {this.state.taxonomyMaps.map(map => {
                            return (
                                <div tabIndex="0"
                                    key={map.modelId}
                                    className={
                                        "dropdown-model-item cursor-pointer" + (
                                            (map.modelId == 'global' && this.state.attachedModels.length == 0) ||
                                                this.state.attachedModels.indexOf(map.modelId) > -1 ? 'selected' : '')
                                    }
                                    data-id={map.modelId}
                                    onKeyUp={this.onSwitchViewKeyup}
                                    onKeyDown={this.onSwitchKeydown}
                                    onClick={x => { this.addTaxMap(map.modelId) }}
                                >{map.modelName}</div>)
                        })}
                    </div>
                    {/* {this.state.taxonomyOpen &&
                    } */}
                </span>
            </span>
        )
    }
}
export default ActiveView;


// WEBPACK FOOTER //
// ./src/components/Header/ActiveView.js